import {
  RESERVATION_STATUS_COLOR_MAP,
  ReservationStatus
} from '@ac/frontend-individual-reservations-domain/reservations/status';
import { ReservationStatus as ApiReservationStatus } from '@ac/library-api';

export function getReservationStatusColor(
  status?: ApiReservationStatus
): string {
  const color = {
    [ApiReservationStatus.RS]:
      RESERVATION_STATUS_COLOR_MAP[ReservationStatus.Reserved],
    [ApiReservationStatus.DI]:
      RESERVATION_STATUS_COLOR_MAP[ReservationStatus.DueIn],
    [ApiReservationStatus.IH]:
      RESERVATION_STATUS_COLOR_MAP[ReservationStatus.InHouse],
    [ApiReservationStatus.DO]:
      RESERVATION_STATUS_COLOR_MAP[ReservationStatus.DueOut],
    [ApiReservationStatus.CO]:
      RESERVATION_STATUS_COLOR_MAP[ReservationStatus.CheckedOut],
    [ApiReservationStatus.NS]:
      RESERVATION_STATUS_COLOR_MAP[ReservationStatus.NoShow],
    [ApiReservationStatus.CX]:
      RESERVATION_STATUS_COLOR_MAP[ReservationStatus.Cancelled],
    [ApiReservationStatus.DL]:
      RESERVATION_STATUS_COLOR_MAP[ReservationStatus.Deleted]
  };

  return status ? color[status] ?? '000000' : '000000';
}



// WEBPACK FOOTER //
// ./src/utils/getReservationStatusColor.ts